import React, { Component } from 'react';

import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { getuserme, getuserrights } from "../actions/userActions";
import { getTokenLogin } from "../actions/getTokenActions";
import { Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

class SwitchDashboard extends Component {


  componentDidMount() {
    const apitoken = (this.props.apitoken);
    this.props.getTokenLogin(apitoken); 
    this.props.getuserme(apitoken);
    this.props.getuserrights(apitoken)
    this.setcookie(apitoken)

  
}

setcookie (apitoken){
  
  cookies.set('token', apitoken, { path: '/' });
  //console.log(cookies.get('vid'))

}
  render () {
    const apitokencheck = (this.props.apitoken);
    let isdirektvideo = (cookies.get('hostmail'))
    if (isdirektvideo === "undefined"){
    return (
    <div>
      {apitokencheck !== "" ? (
         <>
       
        <Redirect to="/home" />
        </>
        ) : (null)}
  </div>
    )
  }

  if (isdirektvideo !== "undefined"){
    return (
      <div>
      {apitokencheck !== "" ? (
        <>
     
       <Redirect to="/recordings" />
       </>
       ) : (null)}
    </div>
      )
  }

}
}

const mapStateToProps = state => ({
    state: state,
    apitoken:  state.gettocken.apitoken
  });

  const mapDispatchToProps = dispatch => bindActionCreators({
    getTokenLogin: getTokenLogin,
    getuserme: getuserme,
    getuserrights : getuserrights 
    }, dispatch)

  
  
  export default connect(mapStateToProps,mapDispatchToProps)(SwitchDashboard);
  


